
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import WalletCustomerView from "../components/walletCustomerView";
import Footer from "../components/footer";

function WalletCustomerViewPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <WalletCustomerView /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default WalletCustomerViewPage;
